<template>
	<div class="container">
		<div class="common-header-wrap">
			<mt-header class="common-header" :title="$t('Sign Up')">
				<mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
			</mt-header>
		</div>
		<div class="main-content">
			<!-- <div class="topList">
				<div class="list">
					<div class="item" v-for="(item, index) in items" :key="index" v-on:click="onClickItem(item.id)">
						<label class="title" v-bind:class="{
							active: item.id === currentIndex,
							normal: item.id !== currentIndex
						}">{{ getTitle(item) }}</label>
					</div>
				</div>
			</div> -->
			<!-- <flex-line v-if="inviter" :show-border="true" style="margin: 0 0.6rem;padding-left: 0.5rem;">
				<span class="line-name">{{ $t('Invitation code') }}</span>
				<span slot="right">{{ inviter.member_id }}</span>
			</flex-line> -->
			<div>
				<register-by-email />
				<!-- <register-by-mobile v-else-if="currentIndex === 2" /> -->
			</div>
		</div>
	</div>
</template>

<script>
import RegisterByMobile from './RegisterByMobile'
import RegisterByEmail from './RegisterByEmail'
import { mapState, mapMutations, mapActions } from 'vuex'
import { getInviterInfo } from '../../../api/memberRegister'
import flexLine from '../../flexLine'
export default {
	name: 'Register',
	components: {
		flexLine,
		RegisterByMobile,
		RegisterByEmail
	},
	data() {
		return {
			inviter: false,
			currentIndex: 0,
			items: []
		}
	},
	created: function () {
		this.fetchConfig({}).then(
			res => {
				var config = res.result.config_list
				if (config.member_normal_register == 1) {
					this.items.push({ id: 1, title: 'Normal Login' })
					if (!this.currentIndex) {
						this.currentIndex = 1
					}
				}
				if (config.sms_register == 1) {
					this.items.push({ id: 2, title: 'phone Login' })
					if (!this.currentIndex) {
						this.currentIndex = 2
					}
				}
			},
			error => {
				Toast(error.message)
			}
		)
		if (this.inviter_id) {
			getInviterInfo(this.inviter_id).then(res => {
				this.inviter = res.result.member
			})
		}
	},
	computed: {
		...mapState({
			inviter_id: state => state.member.inviterId,
			config: state => state.config.config
		}),
		isFirstTab() {
			if (this.currentIndex === 0) {
				return true
			} else {
				return false
			}
		}
	},
	methods: {
		...mapActions({
			fetchConfig: 'fetchConfig'
		}),
		goBack() {
			this.$router.go(-1)
		},
		getTitle(item) {
			return item ? this.$t(item.title) : ''
		},
		isShowLine(index) {
			return index === this.currentIndex
		},
		onClickItem(index) {
			if (this.currentIndex !== index) {
				this.currentIndex = index
			}
		}
	}
}
</script>

<style scoped lang="scss">
.container {
	min-height: 100vh;
	background: #fff;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;

	.common-header {
		box-shadow: none;
	}

	//background-color: $primaryColor;
	.main-content {
		background: #fff;
		padding: 1rem 0;
	}
}

.topList {
	height: 2rem;
	padding: 1rem $pageSpace;

	.list {
		height: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-content: center;
		align-items: stretch;
		background-color: #fff;
	}

	.item {
		padding: 0 .5rem;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.title {
		text-align: center;
		font-size: $h2;
		color: $formInputColor;
	}

	.active {
		color: $primaryColor;
		font-size: 1.1rem;
	}

	.normal {
		color: #404245;
	}

}
</style>
